import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
function SvgSuccessAlt(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={ref}
      {...props}
    >
      <circle cx={16} cy={16} r={16} fill="#00A674" />
      <path
        fill="white"
        fillRule="evenodd"
        d="M25.3333 11.4005L14.1207 22.6666L8 16.5167L10.0575 14.4495L14.1207 18.5321L23.2759 9.33325L25.3333 11.4005Z"
        clipRule="evenodd"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgSuccessAlt);
export default ForwardRef;
ForwardRef.defaultProps = {
  "aria-hidden": true,
  focusable: "false",
  role: "img",
};
